module.exports = __webpack_public_path__ + "img/logo.75403673.png";